import Vue from 'vue';
import axios from 'axios';
import ServiceUtils from '@/services/_ServiceUtilities.js';

var restModel = 'servicerelationships';
var baseUrl = process.env.apiUrl;
var httpConfig = function() { return {headers: {'x-auth-token': localStorage.getItem('accessToken')}} };

export default {
  getAll(filters, filterMode, limit, sort) {
    return axios.get(baseUrl + '/' + restModel + ServiceUtils.generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },

  getById(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },

  createOne(fields) {
    return axios.post(baseUrl + '/' + restModel, fields, httpConfig());
  },

  replace(id, fields) {
    return axios.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },

  deleteById(id) {
    return axios.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },

  serviceAreas: [
    {'name':'accessibility','description':'Accessibility','imageOn':'/static/img/area__accessibility--on.svg','imageOff':'/static/img/area__accessibility--off.svg'},
    {'name':'baby','description':'Baby Changing','imageOn':'/static/img/area__baby--on.svg','imageOff':'/static/img/area__baby--off.svg'},
    {'name':'bins','description':'Bins','imageOn':'/static/img/area__bin--on.svg','imageOff':'/static/img/area__bin--off.svg'},
    {'name':'doors','description':'Doors','imageOn':'/static/img/area__door--on.svg','imageOff':'/static/img/area__door--off.svg'},
    {'name':'driers','description':'Hand Dryers','imageOn':'/static/img/area__drier--on.svg','imageOff':'/static/img/area__drier--off.svg'},
    {'name':'heating','description':'Heating','imageOn':'/static/img/area__heating--on.svg','imageOff':'/static/img/area__heating--off.svg'},
    {'name':'lighting','description':'Lighting','imageOn':'/static/img/area__light--on.svg','imageOff':'/static/img/area__light--off.svg'},
    {'name':'mirror','description':'Mirror','imageOn':'/static/img/area__mirror--on.svg','imageOff':'/static/img/area__mirror--off.svg'},
    {'name':'paint','description':'Paint','imageOn':'/static/img/area__paint--on.svg','imageOff':'/static/img/area__paint--off.svg'},
    {'name':'toiletpaper','description':'Toilet Paper','imageOn':'/static/img/area__paper--on.svg','imageOff':'/static/img/area__paper--off.svg'},
    {'name':'sanitarybins','description':'Sanitary Bins','imageOn':'/static/img/area__sanitary--on.svg','imageOff':'/static/img/area__sanitary--off.svg'},
    {'name':'sinks','description':'Sinks','imageOn':'/static/img/area__sink--on.svg','imageOff':'/static/img/area__sink--off.svg'},
    {'name':'smell','description':'Smell','imageOn':'/static/img/area__smell--on.svg','imageOff':'/static/img/area__smell--off.svg'},
    {'name':'soap','description':'Soap Dispensers','imageOn':'/static/img/area__soap--on.svg','imageOff':'/static/img/area__soap--off.svg'},
    {'name':'suggestions','description':'Suggestions','imageOn':'/static/img/area__suggestion--on.svg','imageOff':'/static/img/area__suggestion--off.svg'},
    {'name':'toilet','description':'Toilet','imageOn':'/static/img/area__toilet--on.svg','imageOff':'/static/img/area__toilet--off.svg'},
    {'name':'towels','description':'Towels','imageOn':'/static/img/area__towel--on.svg','imageOff':'/static/img/area__towel--off.svg'},
    {'name':'urinals','description':'Urinals','imageOn':'/static/img/area__urinal--on.svg','imageOff':'/static/img/area__urinal--off.svg'},
    {'name':'vending','description':'Vending Machines','imageOn':'/static/img/area__vending--on.svg','imageOff':'/static/img/area__vending--off.svg'},
    {'name':'walls','description':'Walls','imageOn':'/static/img/area__wall--on.svg','imageOff':'/static/img/area__wall--off.svg'},
  ]
}



// WEBPACK FOOTER //
// ./src/services/ServiceRelationshipsService.js